import Vue from 'vue';

// When the request succeeds
const success = (context, data) => {
  context.getBookingById(context.$route.params.id);
  toastr.success(data.msg);
  context.loading = false;
};

// When the request fails
const failed = (context, error) => {
  context.loading = false;
  if (error.response && error.response.data && error.response.data.msg) {
    let errorMsg = error.response.data.msg;

    if (typeof error.response.data.msg == "object") {
      for (let key in errorMsg) {
        if (errorMsg.hasOwnProperty(key)) {
          toastr.error(errorMsg[key]);
        }
      }
    } else {
      toastr.error(errorMsg);
    }
  } else {
    toastr.error(error);
  }
};

export default (context, bookingId, invoices) => {
  return Vue.$http.post(`/save-invoice/${bookingId}`, {invoices}).then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    })
    .catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/invoice/save.js